import { ArchivedChatsSettings } from './archived-chats-settings';
import { CustomSkillsSettings } from './custom-skills-settings';
import { NotificationSettings } from './notification-settings';
import { NovaAnalyticsSettings } from './nova-analytics-settings/nova-analytics-settings';
import { NovaSchedulesSettings } from './nova-schedules-settings';
import { OutlookConnectSettings } from './outlook-connect-settings';
import { useActiveSettingsSection } from '../hooks/use-active-settings-section';

/**
 * Dedicated settings panel component for chat area.
 * Displays settings content inline within the main chat content area
 * instead of as a modal dialog overlay.
 *
 * Provides SettingsPanelContext so any settings card can push a full-panel
 * sub-view (e.g. the Outlook manage view) without this component needing to
 * know what's inside it.
 */
export function ChatSettingsPanel({ showOutlookConnect = true }: { showOutlookConnect?: boolean }) {
  const activeSettingsSection = useActiveSettingsSection();

  return (
    <div className="flex size-full min-h-0 min-w-0 flex-col">
      <div
        className={`flex min-h-0 flex-1 items-start justify-center overflow-y-auto [scrollbar-gutter:stable_both-edges] ${
          activeSettingsSection === 'analytics'
            ? 'px-4 pt-10 pb-8 sm:px-8'
            : activeSettingsSection === 'skills' || activeSettingsSection === 'scheduled'
              ? 'px-8 pt-10 pb-8'
              : 'p-6'
        }`}
      >
        <div className="flex w-[736px] max-w-full shrink-0 flex-col gap-4">
          {activeSettingsSection === 'analytics' ? (
            <NovaAnalyticsSettings />
          ) : activeSettingsSection === 'skills' ? (
            <CustomSkillsSettings layout="page" />
          ) : activeSettingsSection === 'scheduled' ? (
            <NovaSchedulesSettings />
          ) : (
            <div className="flex w-full max-w-md flex-col gap-4 self-center">
              <NotificationSettings />
              {showOutlookConnect ? <OutlookConnectSettings /> : null}
              <ArchivedChatsSettings />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
